import {Outlet, useLocation} from "react-router-dom";
import Footer from "./Footer";
import Bottom from "./Bottom";
import Ribbon from "./Ribbon";
import Logo from "./Logo";
import JumboTron from "./JumboTron";
import {Navbar} from "./Navbar";
import CartCheckOutButtonFloat from "../components/CartCheckOutButtonFloat";
import useAuth from "../hooks/useAuth";
import {isAuthenticated} from "../functions/isAuthenticated";

export default function RootLayout() {

  const { auth } = useAuth();
  const { pathname } = useLocation();

  return (
    <div className="root-layout">
      <Ribbon/>
      <Logo title="My header" subtitle="subtitle2" />
      <Navbar/>
      <main className="pt-5 pb-5">
        <Outlet />
      </main>
      { pathname === '/' ? <JumboTron/> : null }
      {isAuthenticated(auth) ? <CartCheckOutButtonFloat/> : null}
      <Footer note="Footer Note" />
      <Bottom/>
    </div>
  );
}
